import { createBaseApi } from '../utils/createBaseApi';

export const [fileServiceApi, initFileServiceApi] = createBaseApi(
  {
    name: 'fileServiceApi',
    endpoints: () => ({}),
  },
  { transformCasing: false }
);
